/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs */

const en_gc_search_guides_gridcraft_vs_excel_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare GridCraft vs Excel for cost, XLSX files, formulas, VBA and collaboration. Use a practical workbook test to decide where each tool fits.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从费用、XLSX 文件、公式、VBA 和协作等方面对比 GridCraft 与 Excel，并通过实际工作簿测试判断适用场景。`)
};

/**
* | output |
* | --- |
* | "Compare GridCraft vs Excel for cost, XLSX files, formulas, VBA and collaboration. Use a practical workbook test to decide where each tool fits." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_description = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_description(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_description(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_description as "gc.search_guides.gridcraft_vs_excel.description" }